import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseWidget, NgGridStackWidget } from 'gridstack/dist/angular';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { IColumnDefinition } from '../standard-tile.model';

@Component({
  selector: 'tt-vehicle-info-item',
  standalone: true,
  imports: [CommonModule, FormsModule, NzSelectModule],
  templateUrl: './tile-info-item.component.html',
  styleUrl: './tile-info-item.component.scss'
})
export class TileInfoItemComponent extends BaseWidget {
  @Input() cardConfig?: any;
  @Input() columnDefinition?: IColumnDefinition[];
  selectedProp?: IColumnDefinition;

  compareFn = (i1: any, i2: any) => {
    if (i1 && i2) {
      return i1.field === i2.field;
    }
    return false;
  };

  override deserialize(w: NgGridStackWidget): void {
    super.deserialize(w);
    this.selectedProp = this.cardConfig
      ? this.columnDefinition?.find(el => el.field === this.cardConfig.prop)
      : undefined;
  }

  setProp() {
    Object.assign(this.widgetItem!.input!, { cardConfig: { prop: this.selectedProp?.field } });
  }

}
